import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '../../../../components/TabPanel';
import Box from '@mui/material/Box';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Checkbox, Chip, TableCell } from '@mui/material';
import moment from 'moment';
// API
import { getMdTickets, getMdTicketsCount } from '../../../../api/mdProfileApi';

export default function TicketTrackerTable({ filterForm }) {
  const [value, setValue] = useState(0);
  const [activeTab, setActiveTab] = useState(null);
  const [ticketsCount, setTicketCount] = useState({ all: 0, request: 0, concern: 0 });
  const [tickets, setTickets] = useState({ loading: false, items: [] });

  const handleChange = (event, newValue) => {
    let status;
    if (newValue === 0) {
      status = null;
    }
    if (newValue === 1) {
      status = 'request';
    }
    if (newValue === 2) {
      status = 'issue_concern';
    }

    setValue(newValue);
    setActiveTab(status);
  };

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => moment(row?.transaction_date).format('YYYY-MM-DD'),
    },
    {
      field: 'description',
      headerName: 'Concerns/Issues',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'tasks',
      headerName: 'Action/Tasks',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Box>
          {row?.action_tasks?.map((item, i) => (
            <span style={{ color: item?.archived ? '#c0c0c0' : '#000' }}>
              {i + 1}. {item?.description}
              <br />
            </span>
          ))}
        </Box>
      ),
    },
    {
      field: 'task_status',
      headerName: 'Task Status',
      width: 200,
      flex: 1,
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <TableCell>
          <Box display='flex' flexDirection='column' gap={0}>
            {row?.action_tasks?.map((item, i) => (
              <Checkbox
                checked={item?.status === 'completed' ? true : false}
                size='small'
                sx={{ p: 0 }}
                readOnly
              />
            ))}
          </Box>
        </TableCell>
      ),
    },
    {
      field: 'status',
      headerName: 'Request Status',
      width: 200,
      flex: 1,
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <Chip label={row?.status} color={row?.status === 'Done' ? 'success' : 'warning'} />
      ),
    },
    {
      field: 'date_completed',
      headerName: 'Date Resolved',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        row?.date_completed !== null ? moment(row?.date_completed).format('YYYY-MM-DD') : '-',
    },
    {
      field: 'age',
      headerName: 'Age',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'turn_around',
      headerName: 'Completion Turnaround Time',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
  ];

  const loadAccountManagementTicketsTotal = async () => {
    const request = {
      doctor_id: filterForm?.doctor_id,
      type: activeTab,
      year: filterForm?.year,
    };

    const response = await getMdTicketsCount(request);
    const { code, data } = response?.data;

    if (code === '200') {
      const issueCount = data.find((row) => row.type === 'ISSUE_CONCERN')?.total ?? 0;
      const requestCount = data.find((row) => row.type === 'REQUEST')?.total ?? 0;
      const allCount = issueCount + requestCount;
      setTicketCount({
        ...ticketsCount,
        all: allCount,
        request: requestCount,
        concern: issueCount,
      });
    }
  };

  const loadAccountManagementTickets = async () => {
    setTickets({ ...tickets, loading: true });
    const request = {
      doctor_id: filterForm?.doctor_id,
      type: activeTab,
      year: filterForm?.year,
    };

    const response = await getMdTickets(request);
    const { code, data } = response?.data;

    if (code === '200') {
      setTickets({ ...tickets, loading: false, items: data });
    }
  };

  useEffect(() => {
    loadAccountManagementTicketsTotal();
    loadAccountManagementTickets();
  }, [activeTab, filterForm]);

  return (
    <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', height: 224 }}>
      <Tabs
        orientation='horizontal'
        variant='scrollable'
        value={value}
        onChange={handleChange}
        aria-label='Vertical tabs example'
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab
          label={`All (${ticketsCount?.all})`}
          id='md-ticket-all-tab'
          aria-controls='md-ticket-all-tab'
        />
        <Tab
          label={`Requests (${ticketsCount?.request})`}
          id='md-ticket-request-tab'
          aria-controls='md-ticket-request-tab'
        />
        <Tab
          label={`Concerns (${ticketsCount?.concern})`}
          id='md-ticket-concern-tab'
          aria-controls='md-ticket-concern-tab'
        />
      </Tabs>
      <TabPanel value={value} index={value}>
        <Box
          className='table-container'
          sx={{
            height: `700px`,
            marginBottom: '100px',
            '& .super-app-theme--header': {
              fontWeight: 'bold',
              backgroundColor: '#6B8D3E',
              color: '#fff',
            },
          }}
        >
          <DataGridPro
            loading={tickets?.loading}
            rows={tickets?.items}
            columns={columns}
            initialState={{
              ...tickets?.items?.initialState,
              pagination: {
                pageSize: 50,
              },
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            getRowHeight={() => 'auto'}
            getRowClassName={(params) => {
              return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
            }}
          />
        </Box>
      </TabPanel>
    </Box>
  );
}
